
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 74.083 74.083","height":"280","width":"280"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(.26458 0 0 .26458 -2.646 -2.646)","fill":"#f5f5f5"}},[_c('path',{attrs:{"d":"M116.238 100.399c-4.672-5.315-9.547-10.678-13.613-14.746-12.021-12.021-46.67-29.698-46.67-29.698s17.678 34.648 29.699 46.669c4.066 4.067 9.43 8.942 14.745 13.614a60.374 60.374 0 0115.839-15.839zM90 150c0-3.83.374-7.57 1.06-11.2-7.065-.455-14.306-.8-20.06-.8-17 0-54 12-54 12s37 12 54 12c5.754 0 12.994-.346 20.06-.8A60.241 60.241 0 0190 150zM210 150c0-3.83-.374-7.57-1.06-11.2 7.065-.455 14.306-.8 20.06-.8 17 0 54 12 54 12s-37 12-54 12c-5.754 0-12.994-.346-20.06-.8.686-3.63 1.06-7.37 1.06-11.2zM100.399 183.761c-5.316 4.674-10.679 9.548-14.747 13.616-12.02 12.021-29.697 46.669-29.697 46.669s34.648-17.678 46.668-29.698c4.068-4.068 8.943-9.432 13.616-14.747a60.366 60.366 0 01-15.84-15.84zM150 210c-3.83 0-7.57-.374-11.2-1.06-.454 7.065-.8 14.306-.8 20.06 0 17 12 54 12 54s12-37 12-54c0-5.754-.346-12.994-.8-20.06-3.63.686-7.37 1.06-11.2 1.06zM199.601 183.761a60.291 60.291 0 01-15.84 15.84c4.674 5.316 9.548 10.679 13.616 14.747 12.021 12.021 46.669 29.698 46.669 29.698s-17.678-34.648-29.698-46.669c-4.069-4.068-9.432-8.943-14.747-13.616zM197.376 85.654c-4.067 4.066-8.941 9.43-13.614 14.746a60.314 60.314 0 0115.839 15.839c5.315-4.673 10.679-9.548 14.746-13.614 12.021-12.021 29.698-46.67 29.698-46.67s-34.649 17.678-46.669 29.699zM150 90c3.83 0 7.57.374 11.2 1.06.454-7.065.8-14.306.8-20.06 0-17-12-54-12-54s-12 37-12 54c0 5.754.346 12.995.8 20.06 3.63-.686 7.37-1.06 11.2-1.06z"}}),_c('circle',{attrs:{"cx":"150","cy":"150","r":"47"}})])])
          )
        }
      }
    